/* eslint-disable prettier/prettier */
export enum XuxViewSelector {
  SaveAsNewView = 'StSd',
  NoSavedViewsYet = 'gdRx',
  TypeViewName = 'KxaC',
}
